export default "__VITE_ASSET__BLdLI9UQ__"